<template>
  <PageWrapper isTransparent>
    <template #title> تنظیمات وبسایت </template>

    <!-- DSD-1176	 -->
    <CallPriceSetting></CallPriceSetting>

    <!-- DSD-673 -->

    <!-- <hr /> -->
    <!-- <MatchesSetting></MatchesSetting> -->

    <PopularMasterSetting></PopularMasterSetting>
  </PageWrapper>
</template>

<script>
export default {
  components: {
    PageWrapper,
    CallPriceSetting,
    MatchesSetting,
    PopularMasterSetting,
  },
};

import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import CallPriceSetting from "@/views/components/SiteSettings/CallPriceSetting.vue";
import MatchesSetting from "@/views/components/SiteSettings/MatchesSetting.vue";
import PopularMasterSetting from "@/views/components/SiteSettings/PopularMasterSetting.vue";
</script>
